import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Grid } from "@mui/material";
import Avatar from '@mui/material/Avatar';
import myimage from "../../images/selectedRakibImage.png"

const MyCard = () => {
  return (
    <Card  sx={{ maxWidth: 345, backgroundColor: "transparent", mt: "10px" }}>
      {/* <DarkMode/> */}

      {/* <CardMedia
        component="img"
        maxheight="200"
        // maxheight="250vh"
        sx={{ borderRadius: "50%", padding: "5px 32px" }}
        image="https://avatars.githubusercontent.com/u/57065763?v=4"
        // image="https://www.aalpha.net/wp-content/uploads/2020/12/full-stack-development.gif"
        alt="Rakib IMG"
      /> */}
            <CardContent>
              
            <Avatar
        alt="Remy Sharp"
        src={myimage}
        sx={{ width: 160, height: 160, mx: 'auto' }}
      />
      </CardContent>
      <CardContent>
        <Typography
        className="cardtextwhite"
          variant="h5"
          sx={{
            color: "white",
            textAlign: "center",
          }}
        >
          KAZI ABDUR RAKIB
        </Typography>

        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 12, sm: 12, md: 12 }}
          sx={{ padding: "15px 32px 0px 32px"}}
        >
          <Grid item xs={4} sm={4} md={4}>
            <a href="https://github.com/karakib2k18" target="_blank" rel="noreferrer">
              <GitHubIcon className="iconhovereffect"/>
            </a>
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <a href="https://www.linkedin.com/in/karakib2k18/" target="_blank" rel="noreferrer">
              <LinkedInIcon className="iconhovereffect" />
            </a>
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <a href="https://www.instagram.com/karakib2k18/" target="_blank" rel="noreferrer">
              <FacebookIcon className="iconhovereffect" />
            </a>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MyCard;
